var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.674,
    y: 0.089,
    width: 20,
    height: 20
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.827,5.249L9.827,3.791C9.827,2.816 9.037,2.025 8.061,2.025L5.211,2.025C4.236,2.025 3.445,2.816 3.445,3.791L3.445,16.378C3.445,17.354 4.236,18.144 5.211,18.144L8.061,18.144C9.037,18.144 9.827,17.354 9.827,16.378L9.827,15.052",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(149,149,149)",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.902,10.09L9.004,10.09M9.004,10.09L12.103,6.794M9.004,10.09L12.103,13.385",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(149,149,149)",
      strokeWidth: "1.5px",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutNormal);
export default __webpack_public_path__ + "static/media/logout_normal.1426548c817f3fdcb868d5cb1b2045c9.svg";
export { ForwardRef as ReactComponent };